module.exports = "https://cdn-social.hiplatform.com/images/6481e2561ad342b623766c7fb45b4659.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/man.jpg
// module id = qCaX
// module chunks = 0